import { AxiosResponse } from 'axios';

import { get } from 'services/api';

export const getAll = (id?: string): Promise<AxiosResponse> => get(`getAllBlogs?limit=12&id=${id}`);

export const getOne = (id: string): Promise<AxiosResponse> => get(`getBlog/${id}`);
